<template>
  <div class="review-exam">
    <div class="review-exam__header">
      <h2 class="review-exam__title">
        Review
      </h2>
    </div>
    <div class="review-exam__body">
      <div class="review-exam__body__questions">
        <div class="review-exam__body__questions__details">
          <div class="review-exam__body__questions__details__title">
            Questions
          </div>
          <div class="review-exam__body__questions__details__summary">
            <RadialProgressBar
              :diameter="30"
              :strokeWidth="3"
              innerStrokeColor="#444444"
              startColor="#70FFD4"
              stopColor="#70FFD4"
              :completed-steps="answeredQuestions"
              :total-steps="totalQuestions"
            />
            Completed: {{ answeredQuestions }}/{{ totalQuestions }}
          </div>
        </div>
        <div
          class="review-exam__body__questions__warning"
          v-if="totalQuestions > answeredQuestions"
        >
          <InfoIcon /> You have
          {{ totalQuestions - answeredQuestions }} questions unanswered
        </div>
        <button
          class="btn btn--secondary"
          @click="$emit('go-to-step', steps.QUESTIONS)"
        >
          Return to Questions
        </button>
      </div>
      <div class="review-exam__body__lab" v-if="userLabAttempt">
        <div class="review-exam__body__lab__details">
          <div class="review-exam__body__lab__details__title">
            Hands-on Lab
          </div>
          <div class="review-exam__body__lab__details__summary">
            <span
              class="review-exam__body__lab__details__pill review-exam__body__lab__details__pill--purple"
              >Submitted</span
            >
            <span>{{ userLabAttemptDate }}</span>
          </div>
        </div>
        <button
          class="btn btn--secondary"
          @click="$emit('go-to-step', steps.PRACTICE)"
        >
          Return to Hands-on Lab
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import RadialProgressBar from 'vue-radial-progress'
import { format } from 'date-fns'
import { InfoIcon } from 'vue-feather-icons'

export default {
  name: 'ReviewExam',
  components: {
    RadialProgressBar,
    InfoIcon,
  },
  props: {
    steps: {
      type: Object,
      required: true,
    },
    answeredQuestions: {
      type: Number,
      required: true,
    },
    totalQuestions: {
      type: Number,
      required: true,
    },
    userLabAttempt: {
      type: Object,
      required: false,
      default: () => {
        return null
      },
    },
  },
  computed: {
    userLabAttemptDate() {
      if (!this.userLabAttempt) return ''
      return `Submitted ${format(
        new Date(this.userLabAttempt.created),
        "LLLL d, yyyy 'at' hh:mm a"
      )}`
    },
  },
}
</script>
<style lang="scss" scoped>
.review-exam {
  width: 100%;
  margin-bottom: 150px;
  &__title {
    font-size: rem(40px);
    line-height: 52px;
  }
  &__body {
    padding: 40px 30px 20px 30px;
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    border-radius: 20px;
    &__questions,
    &__lab {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-bottom: 30px;
      &__details {
        margin-right: auto;
        &__title {
          font-weight: bold;
          font-size: rem(20px);
          line-height: 26px;
          margin-bottom: 10px;
        }
        &__summary {
          display: flex;
          align-items: center;
          ::v-deep .radial-progress-container {
            margin-right: 10px;
          }
        }
        &__pill {
          display: flex;
          align-items: center;
          padding: 5px 8px;
          margin-right: 10px;
          color: #1e1e1e;
          background: var(--white);
          box-shadow: 0px 0px 10px rgba(167, 147, 246, 0.5);
          border-radius: 30px;
          &--purple {
            background: #a793f6;
            box-shadow: 0px 0px 10px rgba(167, 147, 246, 0.5);
            border-radius: 30px;
          }
        }
      }
      &__warning {
        color: #ff5e5e;
        display: flex;
        align-items: center;
        margin-right: 40px;
        svg {
          stroke: #ff5e5e;
          margin-right: 15px;
        }
      }
    }
    &__lab {
      border-top: 1px solid var(--tundora-gray);
      padding-top: 30px;
    }
  }
}
</style>
